/**
 * Utilitaire pour logger les erreurs de manière conditionnelle selon l'environnement
 * En production, seuls les messages génériques sont affichés, sans les détails techniques
 */

/**
 * Log une erreur dans la console en tenant compte de l'environnement
 * @param {string} message - Message d'erreur générique
 * @param {any} error - Objet d'erreur ou détails (affiché uniquement en développement)
 */
export const logError = (message, error) => {
  if (process.env.NODE_ENV !== 'production') {
    console.error(message, error);
  } else {
    console.error(message);
  }
};

export default logError;
